import { setItemLocalStorage } from "@utils/function";

// ------------------------------------------------------------
// remove row from favorite table

export default function RemoveRowFromFavorite(
  tableFavorites,
  id,
  selectedPlayers,
  storageName
) {
  const row = tableFavorites.querySelector(`[data-id="${id}"]`);
  row?.remove();

  selectedPlayers = selectedPlayers.filter((x) => x !== id);
  setItemLocalStorage(storageName, selectedPlayers);
}
